import { render, staticRenderFns } from "./repartition-ventes.vue?vue&type=template&id=10ae01ce&scoped=true"
import script from "./repartition-ventes.vue?vue&type=script&lang=js"
export * from "./repartition-ventes.vue?vue&type=script&lang=js"
import style0 from "./repartition-ventes.vue?vue&type=style&index=0&id=10ae01ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae01ce",
  null
  
)

export default component.exports